import { ITransferCoursesDatasource } from './../datasources/transfer_courses_datasource';
import { Course } from './../builders/course_builder';
import { IDefineCommand, IQueryMediator, ICommand, IQuery } from 'core-ts-types';

angular
  .module('capability-ng-transfer')
  .factory(
    'updateReviewCourseStatusCommand',
    (
      defineCommand: IDefineCommand,
      QueryMediator: IQueryMediator,
      ngTransferCoursesDatasource: ITransferCoursesDatasource,
      $http: ng.IHttpService
    ): ICommand => {
      return defineCommand(
        'updateReviewCourseStatusCommand',
        (deferred: ng.IDeferred<IQuery[]>, course: Course, status: boolean) => {
          let _course = ngTransferCoursesDatasource.get(course.id) as Course;
          _course.isReviewed = status;
          ngTransferCoursesDatasource.put(_course);
          deferred.resolve(QueryMediator.runQueries(ngTransferCoursesDatasource));
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/update_review_course_status_command.ts